import {each, isString} from "lodash"

const initialModalStates = (arr) => {
  const obj = {}
  arr.forEach((item) => {
    obj[item] = false
  })

  return obj
}


export default (states, modalToShow, previous) => {
  const show = initialModalStates(states)
  each(show, (modal, key) => {
    show[key] = modalToShow === key
  })

  if (isString(show.previous)) {
    throw new Error("modalStory: reserved key 'previous' used")
  }
  show.previous = previous

  return show
}

export const anyStoriesOpen = (show) => {
  let anyOpen = false
  each(show, (item) => { if (item === true) anyOpen = true })

  return anyOpen
}
